import Module, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import { DayWelfareView } from "./day_welfare_view";
import { TaskHelp, TaskCode } from "../gametask/task_help";
import ActivityUtil from "../activity/activity_util";
import ModuleManager from "../../../../framework/core/module_manager";
import Utility from "../../../../utility/utility";
import { WelfareAnimComp } from "./welfare_anim_comp";
const {ccclass, property} = cc._decorator;

//在线奖励
@ccclass
@moduleInit('DayWelFareModule')
export class DayWelFareModule extends Module<DayWelfareView,null> {

    private hideCallback : Function;

    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = "package/hall/module/daywelfare/daywelfare";
        this.viewType = DayWelfareView
        this.modelType = null
        this.autoShowAnim = true
        this.needAnim = true
        this.needViewMask = true
        this.needViewBaseCloseBtn = true;
        this.needViewBaseTitleBg = false
        this.needViewBaseBgMini = false
        this.needDeferShow = true
        this.clickAnywhereClose = false;
    }

    activityId = null;
    goldNumb:string = '';
    curIndex=0;
    onLoad(){
        this.eventBind('_welfare_anim_over',this.animOver)
    }

    onDeferShow(){
        this.getTaskDetail((data:any)=>{
            if (!data.progress.isFinish) {
                this.show();
                this.view.resetAnim();
            }else{
                this.hide();
            }
        })
    }

    onShow(intentData?:any){

        this.hideCallback = intentData ? intentData["hideCallback"]:null;


    }


    getTaskDetail(cb?:Function){
        let self = this;
        TaskHelp.getTaskDetail(TaskCode.day_welfare,(data:any)=>{
            self.activityId = data.activityId
            self.eventDispatch('_update_daywelfare_',data);
            self.view.updateDayWelfare(data,()=>{
                self.hide();
            });
            cb && cb(data);
        },()=>{},this);
    }

    @bindButtonClickEvent('awardGoldBtn')
    awardGoldBtn(){
        let self = this;
        TaskHelp.requestDrawActivityAward(this.activityId, function(data){
            ModuleManager.instance.hideModule("NetPrompt");
            let chipNum = 0
            let goldNum = 0
            if(data && data.length > 0){
                for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    if(element.activityAmountType == 5){
                        chipNum += Number(element.amount)
                    }else if(element.activityAmountType == 6){
                        goldNum += Number(element.amount)
                    }
                } 

                self.curIndex = 0;
                self.goldNumb = goldNum.toString();
                self.view.startAnimEffect(self.goldNumb);
                TaskHelp.saveDayWelfareState(0);
                self.getTaskDetail();         
            }
        }, function(){},this);
    }

    animOver(){
        this.curIndex++;
        if (this.curIndex == this.goldNumb.length) {
            this.scheduleOnce(()=>{
                this.showAwardAnim();
            },1.2)
        }
    }

    onHide(){
        //是否有奖励领取
        this.showAwardAnim();
        this.view.stopSound()

        if (this.hideCallback) {            
            this.hideCallback();
            this.hideCallback = null;
        }
    }

    showAwardAnim(){
        if (this.goldNumb.length > 0) {//有奖励可领取
            this.getSelfCurrencyData(null, true)
            this.eventDispatch('player_coinbalance_changed');
            ModuleManager.instance.showModuleName('DialogReceive', {chipNum: null, goldNum: Number(this.goldNumb)})  
            this.goldNumb = ''
        }
    }



    @bindButtonClickEvent('close')
    closeBtn(){
        // this.view.canAwardWelfare(true);
        // Utility.setGray(this.view.awardBg.getComponent(cc.Sprite))
        // this.view.awardBg.active = true;
        this.hide();
        // this.curIndex = 0;
        // this.goldNumb = '124'
        // this.view.startAnimEffect(this.goldNumb);
    }
}
